import { client } from '../utils/fetch';
import { Sensor } from '../types/Sensor';

export const getSensors = async (
  storeId: string
): Promise<Sensor[]> => {
  const headers = {
    'Content-Type': 'application/json;charset=UTF-8',
  };

  try {
    const response = await client.get<Sensor[]>(
      `sensors?store_id=${storeId}`,
      headers
    );
    return response;
  } catch (error) {
    console.error("Error fetching sensors:", error);
    throw error;
  }
}; 